"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
exports.propTypes = {
    listStyle: prop_types_1.default.string,
    listStyleType: prop_types_1.default.string,
    listStyleImage: prop_types_1.default.string,
    listStylePosition: prop_types_1.default.string
};
exports.propAliases = {};
exports.propValidators = {};
const listStyle = {
    className: 'ls',
    cssName: 'list-style',
    jsName: 'listStyle',
    complexValue: true
};
const listStyleType = {
    className: 'ls-typ',
    cssName: 'list-style-type',
    jsName: 'listStyleType'
};
const listStyleImage = {
    className: 'ls-img',
    cssName: 'list-style-image',
    jsName: 'listStyleImage',
    complexValue: true
};
const listStylePosition = {
    className: 'ls-pos',
    cssName: 'list-style-position',
    jsName: 'listStylePosition',
    safeValue: true
};
exports.propEnhancers = {
    listStyle: (value) => get_css_1.default(listStyle, value),
    listStyleType: (value) => get_css_1.default(listStyleType, value),
    listStyleImage: (value) => get_css_1.default(listStyleImage, value),
    listStylePosition: (value) => get_css_1.default(listStylePosition, value)
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGlzdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbmhhbmNlcnMvbGlzdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLDREQUFrQztBQUNsQyx5REFBK0I7QUFHbEIsUUFBQSxTQUFTLEdBQXFCO0lBQ3pDLFNBQVMsRUFBRSxvQkFBUyxDQUFDLE1BQU07SUFDM0IsYUFBYSxFQUFFLG9CQUFTLENBQUMsTUFBTTtJQUMvQixjQUFjLEVBQUUsb0JBQVMsQ0FBQyxNQUFNO0lBQ2hDLGlCQUFpQixFQUFFLG9CQUFTLENBQUMsTUFBTTtDQUNwQyxDQUFBO0FBRVksUUFBQSxXQUFXLEdBQWdCLEVBQUUsQ0FBQTtBQUU3QixRQUFBLGNBQWMsR0FBbUIsRUFBRSxDQUFBO0FBRWhELE1BQU0sU0FBUyxHQUFHO0lBQ2hCLFNBQVMsRUFBRSxJQUFJO0lBQ2YsT0FBTyxFQUFFLFlBQVk7SUFDckIsTUFBTSxFQUFFLFdBQVc7SUFDbkIsWUFBWSxFQUFFLElBQUk7Q0FDbkIsQ0FBQTtBQUNELE1BQU0sYUFBYSxHQUFHO0lBQ3BCLFNBQVMsRUFBRSxRQUFRO0lBQ25CLE9BQU8sRUFBRSxpQkFBaUI7SUFDMUIsTUFBTSxFQUFFLGVBQWU7Q0FDeEIsQ0FBQTtBQUNELE1BQU0sY0FBYyxHQUFHO0lBQ3JCLFNBQVMsRUFBRSxRQUFRO0lBQ25CLE9BQU8sRUFBRSxrQkFBa0I7SUFDM0IsTUFBTSxFQUFFLGdCQUFnQjtJQUN4QixZQUFZLEVBQUUsSUFBSTtDQUNuQixDQUFBO0FBQ0QsTUFBTSxpQkFBaUIsR0FBRztJQUN4QixTQUFTLEVBQUUsUUFBUTtJQUNuQixPQUFPLEVBQUUscUJBQXFCO0lBQzlCLE1BQU0sRUFBRSxtQkFBbUI7SUFDM0IsU0FBUyxFQUFFLElBQUk7Q0FDaEIsQ0FBQTtBQUVZLFFBQUEsYUFBYSxHQUFrQjtJQUMxQyxTQUFTLEVBQUUsQ0FBQyxLQUE0QixFQUFFLEVBQUUsQ0FBQyxpQkFBTSxDQUFDLFNBQVMsRUFBRSxLQUFLLENBQUM7SUFDckUsYUFBYSxFQUFFLENBQUMsS0FBNEIsRUFBRSxFQUFFLENBQUMsaUJBQU0sQ0FBQyxhQUFhLEVBQUUsS0FBSyxDQUFDO0lBQzdFLGNBQWMsRUFBRSxDQUFDLEtBQTRCLEVBQUUsRUFBRSxDQUFDLGlCQUFNLENBQUMsY0FBYyxFQUFFLEtBQUssQ0FBQztJQUMvRSxpQkFBaUIsRUFBRSxDQUFDLEtBQTRCLEVBQUUsRUFBRSxDQUFDLGlCQUFNLENBQUMsaUJBQWlCLEVBQUUsS0FBSyxDQUFDO0NBQ3RGLENBQUEifQ==